import { render, staticRenderFns } from "./DefaulBarragan.vue?vue&type=template&id=71116e4c&scoped=true&"
import script from "./DefaulBarragan.vue?vue&type=script&lang=js&"
export * from "./DefaulBarragan.vue?vue&type=script&lang=js&"
import style0 from "./DefaulBarragan.vue?vue&type=style&index=0&id=71116e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71116e4c",
  null
  
)

export default component.exports